import React, { FC } from 'react'

import { LoadingSpinner } from '../../@paco/components'
import { UserWithHourBalances } from '../../@paco/entities/HourBalances/HourBalances'

import PayrollPeriodNavigator from '../../components/PayrollPeriodNavigator/PayrollPeriodNavigator'
import EmployeeSaldoGroup from '../../compositions/EmployeeSaldoGroup/EmployeeSaldoGroup'
import { PayrollPeriod } from '../../models'

import './EmployeeBalancesPerPeriod.scss'


interface EmployeeBalancesPerPeriodProps {
    loading: boolean;
    activePayrollPeriod: PayrollPeriod;
    className?: string;
    hourBalances?: UserWithHourBalances
    switchPayrollPeriod: (nextPeriod: boolean) => void;
}

const EmployeeBalancesPerPeriod: FC<EmployeeBalancesPerPeriodProps> = ({
    loading,
    activePayrollPeriod,
    hourBalances,
    switchPayrollPeriod,
}) => (
    <div className="employee-balances-per-period">
        {loading && <LoadingSpinner />}
        <PayrollPeriodNavigator
            className="loket-balances-per-period__period-navigator"
            payrollPeriod={activePayrollPeriod}
            switchPayrollPeriod={switchPayrollPeriod}
        />
        {hourBalances && <EmployeeSaldoGroup {...hourBalances} />}
    </div>
)

export default EmployeeBalancesPerPeriod
